/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import $http from '../plugins/axios';

const fetchLearnerStatusForReview = async (learnerTaskId: string) => {
  // let reReviewStatusResponse: any;
  // try {
  //   await $http.get(`/learnerRereviewStatus/${learnerTaskId}`).then((response) => {
  //     reReviewStatusResponse = response.data;
  //     return reReviewStatusResponse;
  //   });
  //   return reReviewStatusResponse;
  // } catch (error) {
  //   return error;
  // }
  const reReviewStatusResponse = await $http.get(`/learnerRereviewStatus/${learnerTaskId}`);
  return reReviewStatusResponse;
};

const requestForRereview = async (learnerTaskId: string, requestFromAdmin: boolean) => {
  // try {
  //   let res: any;
  //   await $http.post('/learnerRereview/', { learner_task_id: learnerTaskId, requestFromAdmin }).then((response) => {
  //     res = response.data;
  //     return res;
  //   });
  //   return res;
  // } catch (error) {
  //   return error;
  // }
  const res = await $http.post('/learnerRereview', { learner_task_id: learnerTaskId, requestFromAdmin });
  return res;
};
export { fetchLearnerStatusForReview, requestForRereview };
